<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Gino Holland grew up and still lives in south-eastern Wisconsin. He began writing at an early age, experimenting with various sorts of mediums and genres before finally settling on science fiction and fantasy in high school. It wasn’t until he met his wife, April, and learned about National Novel Writing Month that he began writing in earnest. He has already had one of those endeavors, <em>What You Wish For</em>, published, and it was one of the greatest days of his life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?434ef8a7